export default __webpack_public_path__ + "static/media/ps-t-scores-coming-soon.1ac72a69.png";